import { Component, OnInit, OnDestroy, Input } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';
import { LatestExportsService } from './latest-exports.service';
import { NotificationItem } from '../../notification-item';
import { WindowRef } from '../core/domain/window-ref';

@Component({
  selector: 'adminui-latest-export',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './latest-export.component.html',
})
export class LatestExportComponent implements OnInit, OnDestroy {
  @Input({ alias: 'message', required: true }) message: { [key: string]: string; } = {};

  exports: NotificationItem[] = [];

  private destroy$ = new Subject<void>();

  constructor(private latestExportsService: LatestExportsService, private windoRef: WindowRef) { }

  ngOnInit(): void {

    this.latestExportsService.latestExports$
      .pipe(takeUntil(this.destroy$))
      .subscribe(exports => {
        this.exports = exports;
      });
  }

  downloadExport(event: Event, exportItem: NotificationItem): void {
    event.preventDefault();
    if (exportItem.url) {
      this.exports = this.latestExportsService.markAsViewed(exportItem.notificationId);
      this.windoRef.open(exportItem.url, '_blank');
    }
  }

  clearExport(event: Event, exportItem: NotificationItem): void {
    event.preventDefault();
    event.stopPropagation();
    this.latestExportsService.removeExport(exportItem.notificationId);
  }

  clearAllExports(event: Event): void {
    event.preventDefault();
    this.latestExportsService.clearAll();
  }

  minimizePanel(event: Event): void {
    event.preventDefault();
    this.latestExportsService.closeLatestExportsPanel();
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
